import React from "react";
import authorImg from "../../asserts/Image.JPG";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="aboutUs-container">
      <div className="A-left bg-primary">
        <div className="about-us-title uppercase">Meet the face behind the posts</div>
        <div className="about-us-desc">
          Welcome to my blog! I'm a Publicist and Marketer currently based in
          the beautiful city of Munich, Germany. Originally from Mumbai, India,
          I have a passion for exploring the world around me and discovering new
          things.
          <br /> <br />
          Through my blog, I'll be sharing my personal experiences and insights
          on a range of important topics, including a healthy lifestyle, mind,
          and soul. I'm excited to take you on my journey of self-discovery,
          learning from the mistakes and growth, and I hope that my stories will
          inspire and motivate you in your own journey.
          <br /> <br />
          Aside from writing, I love to practice yoga, read novels, experiment
          with new recipes in the kitchen, and capture beautiful moments with my
          camera as I explore the city. <br /> <br />
          Thank you for joining me on this adventure, and I hope you enjoy
          reading my blog as much as I enjoy writing it!
        </div>
      </div>
      <div className="A-right shadow-lg shadow-secondary">
        <img src={authorImg} alt="authorImage" className="border-2 border-primary"/>
      </div>
    </div>
  );
};

export default AboutUs;
